<template lang="pug">
  section#intro.intro
    .text-block.section-title
      h1 The Journey to Buying<br>a Holiday Gift
    .text-block.one(data-animate="true")
      p <span class="spacer">They’re making their lists — and checking them twice. As the “official” holiday shopping kickoff looms, <span class="bold">more than 165 million Americans</span> plan to shop in stores or online between Thanksgiving Day and Cyber Monday. Be prepared for a fast start:<br>With six fewer shopping days between Thanksgiving and Christmas this year, the countdown is on.</span><br>Today’s shoppers enjoy both the experience of the holiday rush in physical stores as well as the convenience of shopping from home on their devices. And from decorations to gifts, shoppers are in a buying mood this&nbspseason.
    .text-block.two(data-animate="true")
      h4 How many people plan to shop for the holidays?
      h2 165 million+ Americans
      p shop either in stores or online from Thanksgiving Day through Cyber Monday.<span class="super"><a href="https://nrf.com/media-center/press-releases/thanksgiving-weekend-multichannel-shopping-almost-40-percent-over-last" target="_blank">1</a></span>
    MainImgMobile.mobile
    .text-block.three(data-animate="true")
      h4 How much do people spend on holiday gifts each year?
      .text-block-small.left-block
        h2 $1,007
        p The amount consumers planned to spend, on average, for items such as decorations, candy, and gifts as well as other purchases for themselves and their families.<span class="super"><a href="https://www.slideshare.net/NationalRetailFederation/holiday-2018-consumer-trends" target="_blank">2</a></span>
      .text-block-small.right-block
        h2 $93
        p Amount by which the multichannel shopper outspent the single-channel shopper.<span class="super"><a href="https://www.slideshare.net/NationalRetailFederation/holiday-2018-consumer-trends" target="_blank">2</a></span>
    MainImg.desktop
</template>

<script>
import MainImg from '@/assets/img/intro/main-img.svg'
import MainImgMobile from '@/assets/img/intro/main-img-mobile.svg'
import AnimationManager from '../scripts/AnimationManager'
import { TimelineLite, Elastic } from 'gsap'

export default {
  name: 'intro',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const bagTag = document.querySelector('.blueBagTag')
  
    this.tagAnimation = new TimelineLite({ paused: true })
      .set(bagTag, {transformOrigin: '50% 12%'}) 
      .to(bagTag, .25, {rotation:-20}, 0)
      .to(bagTag, .25, {rotation: 20}, 0.25)
      .to(bagTag, .25, {rotation:0}, 0.5)

    AnimationManager.onEnterView(bagTag, () => {
      this.tagAnimation.seek(0)
      this.tagAnimation.play()
    }, true)
  },
  computed: {
  },
  methods: {
  },
  components: {
    MainImg,
    MainImgMobile,
  },
}
</script>

<style scoped lang="scss">
.intro {
  padding-left: 8%;
  padding-bottom: 4rem;
  background-size: 1600px auto;
  position: relative;

  h4 {
    color: #000;
  }

  .section-title {
    text-align: center;
    top: 14%;
    left: 50%;
    transform: translateX(-50%);
  }

  .text-block {
    &.one {
      width: 29%;
      left: 13%;
      top: 30%;
      .spacer {
        display: inline-block;
        margin-bottom: 2rem;
      }
    }

    &.two {
      width: 28%;
      top: 61%;
      right: 24%;
    }

    &.three {
      top: 80%;
      left: 13%;
      width: 44%;
      h4 {
        max-width: 73%;
      }
    }
  }

  .left-block {
    width: 49%;
    margin-right: 6%;
  }

  .right-block {
    width: 45%;
  }

  @media #{$mobile} {
    padding: 4rem 20rem;

    .section-title {
      position: relative;
      padding-bottom: 2rem;
    }

    .text-block {
      &.one {
        width: 76%;
        left: 12%;
        top: 39%;
        text-align: center;
        .spacer {
          margin: 0;
        }
        br {
          display: none;
        }
      }

      &.two {
        width: 28%;
        top: 54%;
        right: 20%;
      }

      &.three {
        padding-top: 4rem;
        position: relative;
        left: 10%;
        width: 80%;
        h4 {
          max-width: none;
        }
      }
    }

    .text-block-small {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
